<template>
  <div>
    <el-row>
      <el-col>
        <div class="body">
          <div class="bg01">
            <div class="header">
              <h1 class="header-title"><span style="color: white" @click="querySale">和圣柳科技数据看板</span></h1>
              <div id="logInfo" style="text-align: left;color: #fff;position: relative;left: 10px;margin-top: -32px;">
                <el-form :model="formInline" class="searchBar">
                  <el-row>
                    <el-col :span="3">
                      <el-date-picker
                          style="width: 130px !important"
                          size="mini"
                          v-model="formInline.startDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="开始时间"
                      >
                      </el-date-picker>
                    </el-col>
                    <el-col :span="3">
                      <el-date-picker
                          style="width: 130px !important"
                          size="mini"
                          v-model="formInline.endDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="选择日期"
                      >
                      </el-date-picker>
                    </el-col>
                    <el-col :span="18">
                    <div style="text-align: right;color: #fff;position: relative;right: 10px;font-size: 14px;color: yellow;right: 30px">
                      <label>今日交易额：{{todaySale}}</label>
                      <label>今日交易数：{{todayNo}}</label>
                    </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>

            </div>
            <div class="wrapper">
              <div class="content">
                <div class="col col-l">
                  <div class="xpanel-wrapper xpanel-wrapper-100">
                    <div class="xpanel xpanel-l-t">
                      <div class="title">业务员</div>
                      <div class="bcontent">
                        <ul>
                          <div v-for="(user, index ) in userData" @click="selectCustomer(user)">
                            <li class="leftrt">{{ index + 1 }} </li>
                            <li class="rightrt">{{ user.realName }}</li>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col col-c">
                  <div class="xpanel-wrapper xpanel-wrapper-50">
                    <div  class="xpanel xpanel-c-b">
                      <div class="title title-long" style="padding-left:25px"><span style="color:red">{{customerEdit.customer}}  </span>交易金额</div>
                      <div id="echartsSale" class="bcontent" style="height:100%;">
                      </div>
                    </div>
                  </div>
                  <div class="xpanel-wrapper xpanel-wrapper-50">
                    <div  class="xpanel xpanel-c-b">
                      <div class="title title-long" style="padding-left:25px"><span style="color:red">{{customerEdit.customer}}  </span>  利润</div>
                      <div id="echartsId" class="bcontent" style="height:100%;">
                      </div>
                    </div>

                  </div>
                </div>
                <div class="col col-r">
                  <div class="xpanel-wrapper xpanel-wrapper-50" >
                    <div class="xpanel xpanel-r-m">
                      <div class="title"> <span style="color:red">{{userName}}</span> 客户</div>
                      <div class="bcontent">
                        <ul>
                          <div v-for="(cus, index ) in customerData" @click="selectCustomerWarn(cus)">
                            <li class="c_left">{{ index + 1 }} </li>
                            <li class="c_right">{{ cus.customer }}</li>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="xpanel-wrapper xpanel-wrapper-50" >
                    <div class="xpanel xpanel-r-b">
                      <div class="title">
                        <span style="color: red">
                          {{customerEdit.customer ? customerEdit.customer.slice(0,14) : '预警值设置'}}
                        </span>
                      </div>
                      <div class="bcontent">


                        <el-form label-width="100" :model="customerEdit" ref="customerEdit" v-if="customerEdit.customer"
                                 style="margin-top: 15% ;margin-left: 0%;">
                          <el-form-item label="预警利润:">
                            <el-input
                                size="small"
                                v-model="customerEdit.maxProfit"
                                auto-complete="off"
                                placeholder="预警利润"
                                style="width: 50% ;"
                            ></el-input>
                          </el-form-item>
                          <el-form-item label="预警金额:">
                            <el-input
                                size="small"
                                v-model="customerEdit.maxSale"
                                auto-complete="off"
                                placeholder="预警金额"
                                style="width: 50%"
                            ></el-input>
                          </el-form-item>
                          <el-form-item align="center">
                            <el-button type="primary" @click="submitCustomerWarn">提交</el-button>
                            <el-button type="primary" @click="submitForm('dynamicValidateForm')">重置</el-button>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


  </el-col>
</el-row>
  </div>
</template>

<style>
.body {
  width:100%;
  height:100%;
  min-height:830px;
  background-color:#0f1c30;
  background-repeat:no-repeat;
  background-position:center;
  background-size:100% 100%;
  overflow-x:hidden;
  overflow-y:auto;
}
.body {margin:0 auto;min-width:375px;max-width:1920px;}
.bg01 {background-image:url("../../../assets/img/bg01.png");}
.header {margin:0 auto;position:relative;width:100%;
  height:65px;max-width:1920px;
  background:url("../../../assets/img/header.png") center no-repeat;box-sizing:border-box;}
.header-title {
  margin:0;
  padding:0;
  line-height:50px;
  text-align:center;
  font-size:22px;
  color:#5dc2fe;
}

.wrapper {position:absolute;top:68px;bottom:0;left:0;right:0;min-height:555px;}
/* PC */
@media (max-width:1919px) {
  .header {height:65px;}
  .header-title {line-height:50px;font-size:22px;}
  .wrapper {top:68px;}
}
/* Mobile */
@media (max-width:1279px) {
  .header-title {max-width:96%;}
  .wrapper {background:none;}
}

/********** Content **********/
.content {
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  height:100%;
  width:100%;
  min-height:100%;
  box-sizing:border-box;
}
.col {margin:0px 5px 0px;;height:100%;min-width:120px;}
.col-l {-webkit-flex:1.5;-ms-flex:1.5;flex:0.5;}
.col-c {-webkit-flex:4;-ms-flex:4;flex:4;}
.col-r {-webkit-flex:1.5;-ms-flex:1.5;flex:1.5;}
/* PC */
@media (max-width:1919px) {
  .content {padding:10px 0;}
}
/* Mobile */
@media (max-width:1279px) {
  .content {padding:10px 0;}
  .content {
    -webkit-flex-direction:column;
    -ms-flex-direction:column;
    flex-direction:column;
  }
  .col-l,
  .col-c,
  .col-r {-webkit-flex:none;-ms-flex:none;flex:none;}
}
.xpanel-wrapper {padding-bottom:5px;box-sizing:border-box;}
.xpanel-wrapper {height:100%;width:100%}
.xpanel-wrapper-25 {height:27.5%;}
.xpanel-wrapper-30 {height:30%;}
.xpanel-wrapper-40 {height:40%;}
.xpanel-wrapper-45 {height:45%;}
.xpanel-wrapper-60 {height:60%;}
.xpanel-wrapper-100 {height:100%;}
.xpanel-wrapper-50 {height:50%;}
.xpanel-wrapper-55 {height:55%;}
.xpanel-wrapper-70 {height:70%;}
.xpanel {
  height:100%;
  min-height:100px;
  background-repeat:no-repeat;
  background-size:100% 100%;
  box-sizing:border-box;
}
.xpanel-m-c {background-image:url("../../../assets/img/panel.png");}
.xpanel-l-t {background-image:url("../../../assets/img/panel.png");}
.xpanel-l-b {background-image:url("../../../assets/img/panel.png");}
.xpanel-c-b {background-image:url("../../../assets/img/panel.png");}
.xpanel-r-t {background-image:url("../../../assets/img/panel.png");}
.xpanel-r-m {background-image:url("../../../assets/img/panel.png");}
.xpanel-r-b {background-image:url("../../../assets/img/panel.png");}
.xpanel .title {
  font-weight:normal;
  color:#fff;
  background-image:url("../../../assets/img/title-bg.png");
  background-repeat:no-repeat;
  background-size:100% 100%;
}


.xpanel .bcontent {
  line-height:1;
  font-size:15px;
  text-align:left;
  height:95%;
  height:84%;
  /*width:98%;*/
  color:#5dc2fe;
  overflow: scroll;
}


.xpanel .tcontent {
  line-height:1;
  font-size:15px;
  text-align:left;
  height:90%;
  width:98%;
  color:#5dc2fe;
}

.xpanel .no-bg {
  margin:15px;
}
.xpanel .bcontent ul,li{list-style:none;padding:0; margin:1px;}

.xpanel .bcontent ul {
  margin-top:10px;
  clear: both;
  /*overflow: hidden;*/
  height:98%;
}

.xpanel .bcontent ul li {
  height: 35px;
  margin-bottom: 5px;
  float: left;
  font-size:15px;
}
.xpanel .bcontent ul li:nth-child(even) {
  margin-left: 4%;
}

.leftrt{
  width: 20%;
  text-align:right;
  color: #f1ebe5;
  font-weight: bold;

}
.rightrt{
  width: 68%;
  font-weight: bold;
  color: #f1ebe5;
}

.c_left{
  width: 8%;
  text-align:right;
  color: #f1ebe5;
  font-weight: bold;

}
.c_right{
  width: 85%;
  font-weight: bold;
  color: #f1ebe5;
}

.xpanel .title-long { padding-left:24px;background-image:url("../../../assets/img/title-bg-long.png");}
/* PC */
@media (max-width:1919px) {
  .xpanel .title {padding-left:20px;height:36px;line-height:36px;font-size:16px;}
  .xpanel .bcontent{padding:5px 10px;}
}

/* scrollbar */
.bcontent::-webkit-scrollbar {width:0;height:0;}
.bcontent::-webkit-scrollbar-track {background-color:transparent;}
.bcontent::-webkit-scrollbar-thumb {border-radius:5px;background-color:rgba(0, 0, 0, 0.3);}
</style>


<script>
import { querySale,getBussiness ,getCustomer ,getCustomerWarn,submitCustomerWarn,queryTrad,queryOrder} from "@/api/system/customer";
import {monthEndDate, monthStartDate} from "../../../utils";
export default {
  data() {
    return {
      userData: [],
      customerData: [],
      userName:"",
      customerEdit:{},
      todaySale:0,
      todayNo:0,
      formInline: {
        startDate: monthStartDate(new Date()),
        endDate: monthEndDate(new Date()),
        customer:""
      },
    };
  },
  components: {
  },
  mounted() {

  },
  created() {
    this.getBussiness(13);

  },
  methods: {
    querySale() {
      querySale(this.formInline)
          .then((data) => {
            this.todaySale = data.todaySale;
            this.todayNo = data.todayNo;
          })
          .catch(this.$message.error)
          .finally(() => {
          });
    },
    getBussiness() {
      getBussiness(13)
          .then((data) => {
            this.userData = data;
            this.selectCustomer(data[0]);
            // this.formInline.realName = data[0].realName;
            // this.querySale();
          })
          .catch(this.$message.error)
          .finally(() => {
          });
    },
    selectCustomer(item){
      this.userName = item.realName;
      getCustomer(item.realName)
          .then((data) => {
            this.customerData = data;
            this.selectCustomerWarn(data[0]);
            this.formInline.realName = item.realName;
            this.querySale();
          })
          .catch(this.$message.error)
          .finally(() => {
          });
    },
    selectCustomerWarn(item){
      this.customerEdit = item;
      getCustomerWarn(item.id)
          .then((data) => {
            this.customerEdit = data;

            this.queryTrad(data);
            this.queryOrder(data);
          })
          .catch(this.$message.error)
          .finally(() => {
          });
    },
    submitCustomerWarn(){
      submitCustomerWarn(this.customerEdit)
          .then(() => {
            this.$message({
              message: "操作成功",
              type: "success",
            });

          })
          .catch((err) => {
            this.$message({
              message: err.message,
              type: "error",
            });
          });
    },
    queryTrad(){
      this.formInline.customer = this.customerEdit.customer;
      queryTrad(this.formInline).then((data) => {
        this.handleSalePager(data);
      }).catch((err) => {
            this.$message({
              message: err.message,
              type: "error",
            });
          });
    },
    queryOrder(){
      queryOrder(this.formInline).then((data) => {
        this.handlePager(data);
      }).catch((err) => {
        this.$message({
          message: err.message,
          type: "error",
        });
      });
    },
    //利润
    handlePager(data) {
      let myChart = this.$echarts.init(document.getElementById('echartsId'))
      myChart.setOption(
          {
            xAxis: {
              type: 'category',
              data: data.X
            },
            yAxis: {
              type: 'value'
            },
            title: [
              {
                left: '40%',
                text: 'Total：' + data.totalProfit,
                textStyle: {
                  fontSize: 20,
                  color: "rgba(40, 129, 111, 1)",
                  fontFamily: "Courier New"
                }
              },

            ],
            tooltip: {
              trigger: 'axis'
            },
            series: [
              {
                data: data.Y_profit,
                type: 'line',
                smooth: true
              }
            ]
          });
    },
    handleSalePager(data) {
      let myChart = this.$echarts.init(document.getElementById('echartsSale'))
      myChart.setOption(
          {
            xAxis: {
              type: 'category',
              data: data.X
            },
            yAxis: {
              type: 'value'
            },
            title: [
              {
                left: '20%',
                text: 'Today Sale：'+ data.todayTotalSale,
                textStyle: {
                  fontSize: 20,
                  color: "rgba(40, 129, 111, 1)",
                  fontFamily: "Courier New"
                }
              },
              {
                left: '60%',
                text: 'Sale：'+ data.totalSale,
                textStyle: {
                  fontSize: 20,
                  color: "rgba(40, 129, 111, 1)",
                  fontFamily: "Courier New"
                }
              }
            ],
            tooltip: {
              trigger: 'axis'
            },
            series: [
              {
                data: data.Y_sale,
                type: 'line',
                smooth: true
              }
            ]
          });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/customer/echart/index.vue